// src/pages/AccessDenied/RoleGuard.jsx
// Guard temporal basado en rol. Independiente de PermissionsContext.
import React, { useContext } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { AuthContext } from "../../context/AuthContext/AuthContext";
import { canRoleAccessRoute } from "./roleRoutePermissions";

const RoleGuard = ({ children }) => {
  const { user } = useContext(AuthContext);
  const location = useLocation();

  // Si no hay user, dejar pasar (ProtectedRoute ya maneja autenticacion)
  if (!user) return children;

  if (!canRoleAccessRoute(user.rol, location.pathname)) {
    return <Navigate to="/AccessDenied" state={{ from: location.pathname }} replace />;
  }

  return children;
};

export default RoleGuard;
